import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import SearchSelectField from 'src/components/widgets/search-select-field';
import QuillEditor from 'src/components/quill-editor';
import { mergeNoteFromEditor } from 'src/utils/formatters';
import {
  initialValues,
  validationSchema,
  handleSubmitted,
} from './formik';

function getAcronym(text) {
  return text
    .split(' ')
    .map((word) => {
      // Check if the word is a number
      return isNaN(word) ? word.charAt(0).toUpperCase() : word;
    })
    .join('');
}

function getLabelByValue(value, data) {
  const item = data.find((entry) => entry.value === value);
  return item ? item.label : null; // Return null if not found
}

const DetailForm = forwardRef(({ item, options, apiCreate, apiUpdate, apiChange, ...other }, ref) => {
  const editorRef = useRef();

  const [verifyFlag, setVerifyFlag] = useState();
  const [currentStatus, setCurrentStatus] = useState(0);
  useImperativeHandle(ref, () => ({
    onStatusChange: (newStatus) => {
      setCurrentStatus(newStatus);
      setVerifyFlag(newStatus === 1);
    }
  }));

  // Update car options
  const [defaultVal, setDefaultVal] = useState(item || {});
  useEffect(() => {
    if (item) {
      const status = item.status || 0;
      setCurrentStatus(status);
      setVerifyFlag(status === 1);

      const groupName = getLabelByValue(item.type, options);
      setDefaultVal((prev) => ({
        ...prev,
        type: groupName,
        code: item.code,
      }));
    }
  }, [item]);

  useEffect(() => {
    initialValues(formik, item);
  }, []);

  const formik = useCustomFormik({
    validationSchema: validationSchema(defaultVal),

    onSubmit: async (values, helpers) => {
      const mergeValues = mergeNoteFromEditor(values, editorRef, item.info);
      handleSubmitted(mergeValues, item, currentStatus, apiCreate, apiUpdate, apiChange);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        {/* <CardHeader title="Create or Edit" /> */}
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3}>
            <Grid xs={12} md={6}>
              <SearchSelectField
                label="Nhóm"
                name="type"
                formik={formik}
                options={options}
                hintValue={defaultVal.type}
                //onSelected={handleBrandChanged}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <StringTextField
                label="Mã đối tác"
                name="code"
                formik={formik}
                onChangeValue={(val) => {
                  return val.toUpperCase();
                }}
                inputProps={{ maxLength: 10 }}
                hintValue={defaultVal.code}
              />
            </Grid>

            <Grid xs={12}>
              <StringTextField
                label="Tên đối tác"
                name="name"
                formik={formik}
                hintValue={item.name}
                onFocusValue={(val) => {
                  if (!item.name && val) {
                    const general = getAcronym(val);
                    // Auto set code when lost focus
                    formik?.setFieldValue('code', general);
                  }
                }}
              />
            </Grid>

            <Grid xs={12}>
              <QuillEditor
                ref={editorRef}
                value={item.info}
                placeholder="Thông tin đối tác"
                />
            </Grid>

            <Grid xs={12} md={11} display="flex"
              sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
            >
              <SubmitButton
                formik={formik}
                isRemove={true}
                labelRemove={'Khóa đối tác'}
                hasVerified={verifyFlag}
                onVerifyChange={(isVal) => {
                  setVerifyFlag(isVal);
                }} 
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  );
});
export { DetailForm };
DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiDelete: PropTypes.func,
};
